import React, { useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import { Image, Button, Modal, Form, InputGroup } from "react-bootstrap";
import Forget_password_modal_img from "../../../assests/images/ls-page-image/forget-password-modal-img.svg";
import Email_icon from "../../../assests/images/ls-page-image/email.svg";
import {
    CustomModal,
    ModalTitle,
    ModalText,
    ForgetPasswordForm,
    FormSubmitBtn,
} from './forgotPasswordStyle';
import { useFormik } from "formik";
import * as Yup from "yup";
import { REGEX } from "../../../utils/constant";
import { MESSAGE } from "../../../utils/message";
import { useDispatch, useSelector } from "react-redux";
import { forgotUserAction, forgotUserHandler } from '../../../redux/slices/auth/forgot-slice';
interface ForgetPasswordProps {
    editForgetPasswordOpen: boolean;
    setForgetPasswordOpen: (val: boolean) => void;
}

const ForgetPasswordModal: React.FC<ForgetPasswordProps> = ({ editForgetPasswordOpen, setForgetPasswordOpen }: any) => {
    const dispatch: any = useDispatch();
    const forgotUser = useSelector((state: any) => state?.forgotUser);

    useEffect(() => {
        if (forgotUser?.data) {
            if (forgotUser?.data?.status === 200 || forgotUser?.data?.status === 201 || forgotUser?.data?.status === 202) {
                setForgetPasswordOpen(false)
                formik.resetForm({})
            }
            forgotUserAction.forgotSliceReset()

        }
    }, [forgotUser])

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().trim().required(MESSAGE.requiredErrors("Email Address")).matches(REGEX.emailValidate, "Invalid Email Address"),
        }),
        onSubmit: (values: { email: string }) => {
            dispatch(forgotUserHandler({
                email: values.email,
                link: import.meta.env.VITE_WEBSITE_FORGOT_URL + "reset?token="
            }));
        },
    });

    return (
        <Modal show={editForgetPasswordOpen} className='claim-nonprofit-modal forget-password-modal'
            onHide={() => setForgetPasswordOpen(false)} centered>
            <CustomModal className="forget-modal">
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <Image src={Forget_password_modal_img} alt="forget password image" width="299px" height="200px" />
                    <ModalTitle>Forgot Your Password?</ModalTitle>
                    <ModalText>Enter your email to receive instructions on how to reset your password.</ModalText>
                    <ForgetPasswordForm>
                        <Form className="forget-password-form" onSubmit={formik.handleSubmit}>
                            <Form.Group controlId="formBasicEmail" className="form-group">
                                <InputGroup>
                                    <Form.Control
                                        type="email"
                                        placeholder="Email address"
                                        id="email"
                                        name="email"
                                        value={formik.values.email}
                                        onChange={formik.handleChange} />
                                    <InputGroup.Text>
                                        <Image src={Email_icon} alt="Email Icon" width="24px" height="24px" />
                                    </InputGroup.Text>
                                </InputGroup>
                            </Form.Group>
                            {formik.touched.email && formik.errors.email && (
                                <div className="error">
                                    <p>{formik.errors.email}</p>
                                </div>
                            )}
                            <FormSubmitBtn className="forget-password-submit">
                                <Button variant="primary" type="submit" className="btn-outline-success-blue" >{MESSAGE.submitBtn}
                                    {forgotUser?.isLoading && <span className="btnloader"></span>}</Button>
                            </FormSubmitBtn>
                        </Form>
                    </ForgetPasswordForm>
                </Modal.Body>
            </CustomModal>
        </Modal>);
}

export default ForgetPasswordModal;
